/* tslint:disable */
/* eslint-disable */
/**
 * AMJ Accounts Service REST API
 * Maintain AMJ Accounts data
 *
 * The version of the OpenAPI document: 1.0
 * Contact: mail@fidrees.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * AccountControllerApi - axios parameter creator
 * @export
 */
export const AccountControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} userId
         * @param {UserDataDto} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTajneedData: (userId, userDataDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addTajneedData', 'userId', userId);
            // verify required parameter 'userDataDto' is not null or undefined
            assertParamExists('addTajneedData', 'userDataDto', userDataDto);
            const localVarPath = `/api/accounts/v1/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userDataDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveUsers: (userDataDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userDataDto' is not null or undefined
            assertParamExists('approveUsers', 'userDataDto', userDataDto);
            const localVarPath = `/api/accounts/v1/users/approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userDataDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUsers: (userDataDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userDataDto' is not null or undefined
            assertParamExists('disableUsers', 'userDataDto', userDataDto);
            const localVarPath = `/api/accounts/v1/users/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userDataDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableUsers: (userDataDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userDataDto' is not null or undefined
            assertParamExists('enableUsers', 'userDataDto', userDataDto);
            const localVarPath = `/api/accounts/v1/users/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userDataDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/accounts/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserData: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserData', 'userId', userId);
            const localVarPath = `/api/accounts/v1/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: (search, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/accounts/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} roleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByRole: (roleName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'roleName' is not null or undefined
            assertParamExists('getUsersByRole', 'roleName', roleName);
            const localVarPath = `/api/accounts/v1/users/role/{roleName}`
                .replace(`{${"roleName"}}`, encodeURIComponent(String(roleName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectUsers: (userDataDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userDataDto' is not null or undefined
            assertParamExists('rejectUsers', 'userDataDto', userDataDto);
            const localVarPath = `/api/accounts/v1/users/reject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(userDataDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerification: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resendEmailVerification', 'userId', userId);
            const localVarPath = `/api/accounts/v1/users/{userId}/resend-verification`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} [search]
         * @param {Array<string>} [statusFilter]
         * @param {string} [jamaat]
         * @param {string} [country]
         * @param {string} [dateOfBirth]
         * @param {string} [address]
         * @param {string} [urduName]
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [email]
         * @param {string} [aimsId]
         * @param {string} [city]
         * @param {string} [zipCode]
         * @param {string} [state]
         * @param {string} [streetLine1]
         * @param {string} [streetLine2]
         * @param {string} [contactNumber]
         * @param {string} [gender]
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers: (search, statusFilter, jamaat, country, dateOfBirth, address, urduName, firstName, lastName, email, aimsId, city, zipCode, state, streetLine1, streetLine2, contactNumber, gender, page, size, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/accounts/v1/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (statusFilter) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }
            if (jamaat !== undefined) {
                localVarQueryParameter['jamaat'] = jamaat;
            }
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (dateOfBirth !== undefined) {
                localVarQueryParameter['dateOfBirth'] = dateOfBirth;
            }
            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }
            if (urduName !== undefined) {
                localVarQueryParameter['urduName'] = urduName;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (aimsId !== undefined) {
                localVarQueryParameter['aimsId'] = aimsId;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (zipCode !== undefined) {
                localVarQueryParameter['zipCode'] = zipCode;
            }
            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }
            if (streetLine1 !== undefined) {
                localVarQueryParameter['streetLine1'] = streetLine1;
            }
            if (streetLine2 !== undefined) {
                localVarQueryParameter['streetLine2'] = streetLine2;
            }
            if (contactNumber !== undefined) {
                localVarQueryParameter['contactNumber'] = contactNumber;
            }
            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEmailVerified: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('setEmailVerified', 'userId', userId);
            const localVarPath = `/api/accounts/v1/users/{userId}/verify-email`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer Authentication required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AccountControllerApi - functional programming interface
 * @export
 */
export const AccountControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = AccountControllerApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} userId
         * @param {UserDataDto} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTajneedData(userId, userDataDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addTajneedData(userId, userDataDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.addTajneedData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveUsers(userDataDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.approveUsers(userDataDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.approveUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUsers(userDataDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.disableUsers(userDataDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.disableUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableUsers(userDataDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.enableUsers(userDataDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.enableUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMe(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.getMe']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserData(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserData(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.getUserData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(search, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsers(search, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.getUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} roleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByRole(roleName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsersByRole(roleName, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.getUsersByRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectUsers(userDataDto, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.rejectUsers(userDataDto, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.rejectUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerification(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resendEmailVerification(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.resendEmailVerification']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} [search]
         * @param {Array<string>} [statusFilter]
         * @param {string} [jamaat]
         * @param {string} [country]
         * @param {string} [dateOfBirth]
         * @param {string} [address]
         * @param {string} [urduName]
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [email]
         * @param {string} [aimsId]
         * @param {string} [city]
         * @param {string} [zipCode]
         * @param {string} [state]
         * @param {string} [streetLine1]
         * @param {string} [streetLine2]
         * @param {string} [contactNumber]
         * @param {string} [gender]
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(search, statusFilter, jamaat, country, dateOfBirth, address, urduName, firstName, lastName, email, aimsId, city, zipCode, state, streetLine1, streetLine2, contactNumber, gender, page, size, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchUsers(search, statusFilter, jamaat, country, dateOfBirth, address, urduName, firstName, lastName, email, aimsId, city, zipCode, state, streetLine1, streetLine2, contactNumber, gender, page, size, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.searchUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEmailVerified(userId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setEmailVerified(userId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['AccountControllerApi.setEmailVerified']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * AccountControllerApi - factory interface
 * @export
 */
export const AccountControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AccountControllerApiFp(configuration);
    return {
        /**
         *
         * @param {string} userId
         * @param {UserDataDto} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTajneedData(userId, userDataDto, options) {
            return localVarFp.addTajneedData(userId, userDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveUsers(userDataDto, options) {
            return localVarFp.approveUsers(userDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableUsers(userDataDto, options) {
            return localVarFp.disableUsers(userDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableUsers(userDataDto, options) {
            return localVarFp.enableUsers(userDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMe(options) {
            return localVarFp.getMe(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserData(userId, options) {
            return localVarFp.getUserData(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(search, options) {
            return localVarFp.getUsers(search, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} roleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByRole(roleName, options) {
            return localVarFp.getUsersByRole(roleName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<UserDataDto>} userDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectUsers(userDataDto, options) {
            return localVarFp.rejectUsers(userDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerification(userId, options) {
            return localVarFp.resendEmailVerification(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [search]
         * @param {Array<string>} [statusFilter]
         * @param {string} [jamaat]
         * @param {string} [country]
         * @param {string} [dateOfBirth]
         * @param {string} [address]
         * @param {string} [urduName]
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [email]
         * @param {string} [aimsId]
         * @param {string} [city]
         * @param {string} [zipCode]
         * @param {string} [state]
         * @param {string} [streetLine1]
         * @param {string} [streetLine2]
         * @param {string} [contactNumber]
         * @param {string} [gender]
         * @param {number} [page]
         * @param {number} [size]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(search, statusFilter, jamaat, country, dateOfBirth, address, urduName, firstName, lastName, email, aimsId, city, zipCode, state, streetLine1, streetLine2, contactNumber, gender, page, size, options) {
            return localVarFp.searchUsers(search, statusFilter, jamaat, country, dateOfBirth, address, urduName, firstName, lastName, email, aimsId, city, zipCode, state, streetLine1, streetLine2, contactNumber, gender, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEmailVerified(userId, options) {
            return localVarFp.setEmailVerified(userId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AccountControllerApi - object-oriented interface
 * @export
 * @class AccountControllerApi
 * @extends {BaseAPI}
 */
export class AccountControllerApi extends BaseAPI {
    /**
     *
     * @param {string} userId
     * @param {UserDataDto} userDataDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    addTajneedData(userId, userDataDto, options) {
        return AccountControllerApiFp(this.configuration).addTajneedData(userId, userDataDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<UserDataDto>} userDataDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    approveUsers(userDataDto, options) {
        return AccountControllerApiFp(this.configuration).approveUsers(userDataDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<UserDataDto>} userDataDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    disableUsers(userDataDto, options) {
        return AccountControllerApiFp(this.configuration).disableUsers(userDataDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<UserDataDto>} userDataDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    enableUsers(userDataDto, options) {
        return AccountControllerApiFp(this.configuration).enableUsers(userDataDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    getMe(options) {
        return AccountControllerApiFp(this.configuration).getMe(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    getUserData(userId, options) {
        return AccountControllerApiFp(this.configuration).getUserData(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [search]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    getUsers(search, options) {
        return AccountControllerApiFp(this.configuration).getUsers(search, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} roleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    getUsersByRole(roleName, options) {
        return AccountControllerApiFp(this.configuration).getUsersByRole(roleName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<UserDataDto>} userDataDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    rejectUsers(userDataDto, options) {
        return AccountControllerApiFp(this.configuration).rejectUsers(userDataDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    resendEmailVerification(userId, options) {
        return AccountControllerApiFp(this.configuration).resendEmailVerification(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [search]
     * @param {Array<string>} [statusFilter]
     * @param {string} [jamaat]
     * @param {string} [country]
     * @param {string} [dateOfBirth]
     * @param {string} [address]
     * @param {string} [urduName]
     * @param {string} [firstName]
     * @param {string} [lastName]
     * @param {string} [email]
     * @param {string} [aimsId]
     * @param {string} [city]
     * @param {string} [zipCode]
     * @param {string} [state]
     * @param {string} [streetLine1]
     * @param {string} [streetLine2]
     * @param {string} [contactNumber]
     * @param {string} [gender]
     * @param {number} [page]
     * @param {number} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    searchUsers(search, statusFilter, jamaat, country, dateOfBirth, address, urduName, firstName, lastName, email, aimsId, city, zipCode, state, streetLine1, streetLine2, contactNumber, gender, page, size, options) {
        return AccountControllerApiFp(this.configuration).searchUsers(search, statusFilter, jamaat, country, dateOfBirth, address, urduName, firstName, lastName, email, aimsId, city, zipCode, state, streetLine1, streetLine2, contactNumber, gender, page, size, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    setEmailVerified(userId, options) {
        return AccountControllerApiFp(this.configuration).setEmailVerified(userId, options).then((request) => request(this.axios, this.basePath));
    }
}
